import LocalPlayIcon from '@mui/icons-material/LocalPlay'
import { MessageCard } from 'settle-ui/components/MessageCard/MessageCard'

export const OnboardingReferralBanner: Settle.FC = ({ children, ...props }) => (
  <MessageCard
    variant="upsell"
    margin="none"
    {...props}
    slots={{ left: <LocalPlayIcon color="secondary" />, content: children }}
  />
)
